
import moment from 'moment';
import { OBTENIR_DATA_HORA_ACTUAL, OBTENIR_DATA_HORA_ACTUAL_EN_CURS, OBTENIR_DATA_HORA_ACTUAL_FINALITZAT } from './actionTypes';
import { fetchObtenirDataActual } from '../commons/consultesServidor';
import { convertirMomentATextEnUTC } from '../commons/gestioDates';
import { errorConsultaServidor } from './error';

/**
 * Consulta la data actual del servidor i llença una accio de tipus OBTENIR_DATA_HORA_ACTUAL juntament amb l'hora
 * actual del servidor.
 * @returns {Function}
 */
export function obtenirDataHoraActualUTC() {
    return (dispatch) => {
        dispatch(peticioObtenirDataHoraActualUTCEnCurs());

        return fetchObtenirDataActual()
            .then((data) => {
                dispatch(peticioObtenirDataHoraActualUTCFinalitzat());
                dispatch(dataActual(data.dataActual));
            },(errorServidor) => {
                dispatch(peticioObtenirDataHoraActualUTCFinalitzat());
                dispatch(errorConsultaServidor(errorServidor));
                //Si hi ha un error al servidor agafem la data del client.
                const dataActualAsText = convertirMomentATextEnUTC(moment.utc());
                dispatch(dataActual(dataActualAsText));
            });
    };
}

export function peticioObtenirDataHoraActualUTCEnCurs() {
    return {
        type: OBTENIR_DATA_HORA_ACTUAL_EN_CURS
    };
}

export function peticioObtenirDataHoraActualUTCFinalitzat() {
    return {
        type: OBTENIR_DATA_HORA_ACTUAL_FINALITZAT
    };
}

/**
 * Llença l'acció indicant que s'ha d'actualitzar la data actual.
 *
 * @param dataHoraActual {String}
 * @returns {{type: OBTENIR_DATA_HORA_ACTUAL, dataHoraActual: String}}
 */
function dataActual(dataHoraActual) {
    return {
        type: OBTENIR_DATA_HORA_ACTUAL,
        dataHoraActual
    };
}



// WEBPACK FOOTER //
// ./src/actions/data.js